import React, { memo } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import { isNavigationItemActive } from './navigationSelection';
import * as S from './style';

interface IProps {
  value?: number | string;
  selectedValue?: number | string;
  text?: string;
  className?: string;
  bgColor?: string;
  textColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
  onClick?: () => void;
}

const NavigationItem = ({
  value,
  selectedValue,
  text,
  className,
  bgColor = 'white',
  textColor,
  pointColor,
  emphasisTextColor,
  onClick,
}: IProps) => {
  const cName = classNameBind([
    'event-navi-item',
    isNavigationItemActive(value, selectedValue) ? 'active' : '',
    className || '',
  ]);

  return (
    <S.NavigationItem
      className={cName}
      $bgColor={bgColor}
      $textColor={textColor}
      $pointColor={pointColor}
      $emphasisTextColor={emphasisTextColor}
    >
      <Button className="area-click" isDebounced={false} onClick={onClick}>
        {text}
      </Button>
    </S.NavigationItem>
  );
};

export default memo(NavigationItem);
